const admin = {
  menu: 'Administration menu',
  'add-new-queue': 'Add new queue',
  'queues-management': 'Queues management',
  'users-management': 'Users management',
  'queues-report': {
    'header' : 'Queue presence reports',
    'queue-selector' : 'Select queue'
  }
};

export default admin;
